module.exports = __webpack_public_path__ + "static/media/1-01.383182b3.png";